var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 9,
    fill: "#25BCBD",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6094 11H11.19C10.8745 11.0004 10.572 11.1259 10.3489 11.3489C10.1259 11.572 10.0004 11.8745 10 12.19V31.2295C10.0004 31.545 10.1259 31.8474 10.3489 32.0705C10.572 32.2936 10.8745 32.4191 11.19 32.4195H32.6094C32.9249 32.4191 33.2274 32.2936 33.4505 32.0705C33.6735 31.8474 33.799 31.545 33.7994 31.2295V12.19C33.799 11.8745 33.6735 11.572 33.4505 11.3489C33.2274 11.1259 32.9249 11.0004 32.6094 11ZM11.5866 12.5866H16.3465V16.1565H11.5866V12.5866ZM32.2128 30.8328H11.5866V17.7432H32.2128V30.8328ZM32.2128 16.1565H17.9331V12.5866H32.2128V16.1565Z",
    fill: "#25BCBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices2);
export default __webpack_public_path__ + "static/media/Services2.d907bbf5e5a27d4efc54a26734258c90.svg";
export { ForwardRef as ReactComponent };